import React, { useCallback, useMemo } from 'react'

import ActionButton, {
  ActionButtonSize,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'
import FbUnfriendCheckbox from '$extensionSrc/components/FbUnfriendCheckbox'

import styles from './FriendSet.module.scss'

export default function FriendSet({
  index,
  onBatchSelected,
  reviewed,
}: {
  index: number
  onBatchSelected: (index: number) => void
  reviewed: boolean
}) {
  const title = useMemo(() => `Set ${index + 1}`, [index])

  const handleClick = useCallback(async () => {
    onBatchSelected(index)
  }, [index, onBatchSelected])

  return (
    <div className={styles.friendSet}>
      <ActionButton
        onClick={handleClick}
        size={ActionButtonSize.EXTRA_SMALL}
        type={ActionButtonType.SECONDARY}
      >
        {title}
      </ActionButton>
      <FbUnfriendCheckbox checked={reviewed} />
    </div>
  )
}
